<template>
    <div>
      <ProductExplanation :type="type" />
      <CertificateExample :type="type" :vehicle_type="vehicle_type"/>
      <SectionTitle title="In soli 3 click" />
      <Stepper :type="type" />
    </div>
  </template>

  <script>
  import ProductExplanation from './ProductExplanation.vue';
  import CertificateExample from './CertificateExample.vue';
  import SectionTitle from './SectionTitle.vue';
  import Stepper from './Stepper.vue';

  export default {
    name: 'ProductDefinition',
    components: {
      ProductExplanation,
      CertificateExample,
      SectionTitle,
      Stepper,
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      vehicle_type: {
      type: String,
      required: true
    }
    },
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/ProductDefinition.vue